export default {"src":"/_next/static/media/shine.2157e425.svg","height":114,"width":116,"blurWidth":0,"blurHeight":0};